import { Container } from '../components/Container';
import type { LandingContent } from '../content/types';

type TrustBarProps = {
  content: LandingContent;
};

export function TrustBar({ content }: TrustBarProps) {
  return (
    <section className="trust-bar" aria-label="Credibility metrics">
      <Container className="trust-bar__grid">
        {content.trustBar.items.map((item) => (
          <div key={item.label} className="trust-bar__item">
            <strong>{item.value}</strong>
            <span>{item.label}</span>
          </div>
        ))}
      </Container>
    </section>
  );
}
